import type { AnimatedIconComponent } from './types';

type AppIconProps = {
  icon: AnimatedIconComponent;
  className?: string;
  size?: number;
};

/** Renders a lucide-animated icon with consistent size/className props. */
export function AppIcon({ icon: Icon, className, size = 18 }: AppIconProps) {
  return <Icon className={className} size={size} />;
}
